module.exports = __webpack_public_path__ + "static/media/video_call_black_24dp.2859d45a.svg";